<!--  -->
<template>
  <div
    v-loading="loadingr"
    element-loading-text="选择中，请稍后..."
  >
    <div class="tinymce_box">
      <div>
        <div class="tabselecr_box">
          <div class="search_box">
            <el-input v-model="obj.keywords" clearable style="width:200px;" placeholder="请输入消息编号" />
            <el-select v-model="obj.onlyMe" placeholder="请选择">
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
            <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
          </div>
        </div>

        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData.list"
          border
          tooltip-effect="dark"
          style="width: 100%;margin-top:20px"
          max-height="500"
        >
          <el-table-column
            prop="sp_message_no"
            label="编号"
            align="center"
            width="240px"
          />
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          />
          <el-table-column
            prop="content"
            label="消息文本"
            align="center"
            width="160"
          >
            <template slot-scope="scope">
              <div class="content_box">{{ scope.row.content }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_time_text"
            label="创建时间"
            align="center"
          />
          <el-table-column
            align="center"
            prop="realName"
            width="100"
            label="创建人"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="warning" size="mini" @click="priwiter(scope.row)">预览</el-button>
              <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
            </template>
          </el-table-column>

        </el-table>
        <pagination-right
          :current-page="obj.page"
          :total="tableData.total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
        <!-- 预览标签组弹窗 -->
        <el-dialog
          title="预览"
          :visible.sync="priwdialogVisible"
          :modal-append-to-body="false"
          :append-to-body="true"
          width="25%"
        >
          <previewdialog ref="timepreview" />
        </el-dialog>
      </div>

    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spMessagelist, appletCheck } from '@/api/officialaccount.js'
import previewdialog from '../../enterpmessagelist/components/previewdialog.vue'
export default {
  components: { PaginationRight, previewdialog },
  data() {
    return {
      tableData: [],
      obj: {
        page: 1,
        pageSize: 10,
        keywords: '',
        push_method: '',
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内消息'
      }, {
        value: 2,
        label: '我关联的消息'
      }],
      dialogTableVisible: false,
      priwdialogVisible: false,

      type: '1',
      options: [],
      loading: false,
      templatedata: [],
      templatetotalre: null,
      plateoption: [],
      palateid: null,
      alltype: null,
      identifyingtype: null,
      sp_message_no: null,
      loadingr: false
    }
  },
  created() {
    // this.menuList()
  },
  mounted() {

  },
  methods: {
    menuList() {
      this.loading = true
      spMessagelist(this.obj).then(res => {
        console.log('res', res)
        this.tableData = res.data
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.obj.pageSize = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.menuList()
    },

    rechargeclick() {
      this.obj.page = 1
      this.obj.keywords = ''
      // this.obj.onlyMe = 3
      this.menuList()
    },
    searchclick() {
      this.obj.page = 1
      this.menuList()
    },
    send(alltype, push_method, identifyingtype, sp_message_no) {
      console.log('666', push_method)
      console.log('sp_message_no', sp_message_no)
      this.alltype = alltype
      this.obj.push_method = push_method
      this.identifyingtype = identifyingtype
      this.sp_message_no = sp_message_no
      this.menuList()
    },
    choose(item) {
      if (this.alltype === 1) {
        console.log('2222', item)
        // eslint-disable-next-line eqeqeq
        if (this.identifyingtype == 2 && this.obj.push_method == 1) {
          this.loadingr = true
          console.log('请求')
          appletCheck({
            sp_strategy_no: this.sp_message_no,
            sp_message_no: item.sp_message_no
          }).then((res) => {
            this.$emit('callback', item)
            this.loadingr = false
          }).catch((error) => {
            console.log('err', error)
            this.loadingr = false
          })
        } else {
          this.$emit('callback', item)
        }
      } else {
        this.$emit('callbackr', item)
      }
    },
    priwiter(item) {
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item)
      }, 100)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tinymceserve_box{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox{
  width: 200px;
  margin-left: 20px;
}
.functional_area{
  margin-top: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
}
.choose_plate{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text{
  font-size: 14px;
  color: #606266;
}
.template_addbutton{
  text-align: right;
  width: 80%;
}
.sewrw_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box{
  display: flex;
  align-items: center;
}
.content_box{
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
</style>
